import { jss } from "react-jss";
import jssVariables from "../../jss_setup";

export const CarRentalSearchStrip = {
  SearchStrip: {
    background: "#ebf2f2",
    smallscreen: {
      background: "#b9ced8",
    },
  },
  itemType: {
    fontWeight: "bold",
    smallscreen: {
      color: jssVariables.colors.base_color,
      fontWeight: "normal",
    },
  },
  location: {
    borderRadius: 0,
  },
  date: {
    borderRadius: 0,
  },
};

export const CarRentalFilters = {
  FiltersBar: {
    background: "#e8eff2",
    paddingTop: jssVariables.half_gap,
  },
  inputGroupField: {
    label: {
      fontWeight: 600,
    },
  },
};

export const carRentalStyles = {
  priceContr: {
    textAlign: "right",
  },
  priceTitle: {
    fontWeight: 800,
    fontSize: "x-large",
  },
  priceSubTitle: {
    fontWeight: 600,
    fontSize: "small",
  },
  bookBtn: {
    ButtonDefault: {
      background: jssVariables.colors.secondary_color,
      borderColor: jssVariables.colors.secondary_color,
      "&:hover": {
        color: jssVariables.colors.secondary_color,
        background: "white",
      },
    },
  },
};

export const TravellersForms = {
  inputGroup: {
    label: {
      color: "#ababab",
      fontWeight: 700,
    },
  },
};

export const CarPreBook = {
  item: {
    smallscreen: {
      gridTemplateColumns: "repeat(3, max-content)",
    },
  },
};
